import { render, staticRenderFns } from "./databaseManagementForm.vue?vue&type=template&id=2749804a&scoped=true&"
import script from "./databaseManagementForm.vue?vue&type=script&lang=js&"
export * from "./databaseManagementForm.vue?vue&type=script&lang=js&"
import style0 from "./databaseManagementForm.vue?vue&type=style&index=0&id=2749804a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2749804a",
  null
  
)

export default component.exports